'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X, Bell, Search } from 'lucide-react';

const navLinks = [
  { label: 'Browse Events', href: '/event-catalog' },
  { label: 'My Tickets', href: '/attendee-dashboard' },
  { label: 'Organizers', href: '/organizer-dashboard' },
];

export default function PublicTopbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-card border-b border-border shadow-card">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between gap-4">
        <Link href="/" className="flex items-center gap-2 shrink-0">
          <AppLogo size={36} />
          <span className="font-extrabold text-xl text-foreground tracking-tight">Eventz</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks?.map((link) => (
            <Link
              key={`nav-${link?.label}`}
              href={link?.href}
              className="px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-all duration-150"
            >
              {link?.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-all duration-150">
            <Search size={18} />
          </button>
          <button className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-all duration-150">
            <Bell size={18} />
          </button>
          <Link
            href="/sign-up-login-screen"
            className="px-4 py-2 text-sm font-semibold text-muted-foreground border border-border rounded-lg hover:bg-muted transition-all duration-150"
          >
            Sign In
          </Link>
          <Link
            href="/sign-up-login-screen"
            className="px-4 py-2 text-sm font-semibold text-primary-foreground bg-primary rounded-lg hover:opacity-90 active:scale-95 transition-all duration-150"
          >
            Get Started
          </Link>
        </div>

        <button
          className="md:hidden p-2 rounded-lg text-muted-foreground hover:bg-muted transition-all duration-150"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {mobileOpen && (
        <div className="md:hidden border-t border-border bg-card px-6 py-4 flex flex-col gap-2 fade-in">
          {navLinks?.map((link) => (
            <Link
              key={`mob-nav-${link?.label}`}
              href={link?.href}
              className="px-3 py-2 text-sm font-medium text-foreground hover:bg-muted rounded-lg transition-all duration-150"
              onClick={() => setMobileOpen(false)}
            >
              {link?.label}
            </Link>
          ))}
          <div className="pt-2 border-t border-border flex flex-col gap-2">
            <Link
              href="/sign-up-login-screen"
              className="px-3 py-2 text-sm font-semibold text-center border border-border rounded-lg hover:bg-muted transition-all duration-150"
              onClick={() => setMobileOpen(false)}
            >
              Sign In
            </Link>
            <Link
              href="/sign-up-login-screen"
              className="px-3 py-2 text-sm font-semibold text-center text-primary-foreground bg-primary rounded-lg hover:opacity-90 transition-all duration-150"
              onClick={() => setMobileOpen(false)}
            >
              Get Started
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}